import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {  FaArrowRight } from "react-icons/fa6";
function Aboutus() {
 const [currentTestimonial, setCurrentTestimonial] = useState(0);
  
  const testimonials = [
    {
      rating: 5,
      text: "Partnering with ETech has transformed our IT Solution Their tailored solutions help streamline our operations, improve cybersecurity, and drive efficiency across the board. We've experienced fewer disruptions, faster an.",
      name: "Ben Stokes",
      position: "Owner Taxfirm",
      image: "assets/img/all-images/testimonial/testimonial-img2.png"
    },
    {
      rating: 5,
      text: "Partnering with ETech has transformed our IT Solution Their tailored solutions help streamline our operations, improve cybersecurity, and drive efficiency across the board. We've experienced fewer disruptions, faster an.",
      name: "Ben Stokes",
      position: "Owner Taxfirm",
      image: "assets/img/all-images/testimonial/testimonial-img3.png"
    },
    {
      rating: 5,
      text: "Partnering with ETech has transformed our IT Solution Their tailored solutions help streamline our operations, improve cybersecurity, and drive efficiency across the board. We've experienced fewer disruptions, faster an.",
      name: "Ben Stokes",
      position: "Owner Taxfirm",
      image: "assets/img/all-images/testimonial/testimonial-img4.png"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  return (
    <>
        <div className="inner-page-hero-area" style={{backgroundImage: "url(assets/img/all-images/bg/hero-bg1.png)", backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover"}}>
        <img src="assets/img/elements/elements5.png" alt="" className="elements5" />
        <img src="assets/img/elements/elements4.png" alt="" className="elements4" />
        <img src="assets/img/elements/elements1.png" alt="" className="elements1 keyframe5" />
        <img src="assets/img/elements/elements16.png" alt="" className="elements16" />

        <div className="container">
          <div className="row">
            <div className="col-lg-4 m-auto">
              <div className="inner-header text-center heading1">
                <h1>About Us</h1>
                <div className="space28"></div>
                <a href="/">Home <i className="fa-solid fa-angle-right"></i> <span>About Us</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* WORK AREA */}
     <div className="work1-section-area sp1">
  <img src="assets/img/elements/elements11.png" alt="" className="elements9" />
  <div className="container">
    <div className="row align-items-center">
      <div className="col-lg-5">
        <div className="solution-header heading2">
          <h5>
            <span>
              <img src="assets/img/icons/sub-logo1.svg" alt="" />
            </span>
            Welcome To Chestes IT Solutions
          </h5>
          <div className="space24"></div>
          <h2 className="text-anime-style-3">
            To Be Your Complete Digital Partner—From Strategy to Launch and Beyond
          </h2>
          <div className="space16"></div>

          <p data-aos="fade-left" data-aos-duration="800">
            Over the past five years, we’ve collaborated with 50+ clients globally, crafting digital 
solutions that drive efficiency, innovation, and user engagement. Whether it’s building 
custom platforms, AI-powered tools, or enhancing existing systems, our mission is to fast
track your digital vision with precision and excellence.
          </p>
    <div className="space32"></div>
          <p data-aos="fade-left" data-aos-duration="800">
  <b>Key Strengths:</b>
</p>
<p data-aos="fade-left" data-aos-duration="800">
  • Agile Methodology & Certified Professionals<br/>
  • End-to-End Capability: Strategy, Design, Development, QA & Support<br/>
  • Smooth Team Collaboration & Knowledge Sharing<br/>
  • Rapid Turnaround Without Compromising Quality
</p>
          <div className="space32"></div>
          {/* <div
            className="btn-area1"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <a href="contact.html" className="vl-btn2">
              Discover Our Solutions{" "}
              <i className="fa-solid fa-arrow-right"></i>
            </a>
          </div> */}
        </div>
      </div>
      <div className="col-lg-2"></div>
      <div className="col-lg-5">
        <div className="soultions-images">
          <img
            src="assets/img/elements/elements10.png"
            alt=""
            className="elements10"
          />
          <div className="img1 reveal image-anime">
            <img src="assets/img/all-images/work/work-img1.png" alt="" />
          </div>
          <div className="img2 reveal image-anime">
            <img src="assets/img/all-images/work/work-img2.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


      {/* ABOUT AREA */}
     {/* ===== ABOUT AREA STARTS ===== */}
          <div className="about1-section-area sp1">
            <img src="/assets/img/elements/elements9.png" alt="" className="elements9" />
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="about-images-area">
                    <img src="/assets/img/elements/elements10.png" alt="" className="elements10" />
                    <div className="row align-items-center">
                      <div className="col-lg-6 col-md-6">
                        <div className="img1 image-anime reveal">
                          <img src="/assets/img/all-images/about/about-img1.png" alt="" />
                        </div>
                        <div className="space30 d-lg-none d-block"></div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="img1 image-anime reveal">
                          <img src="/assets/img/all-images/about/about-img2.png" alt="" />
                        </div>
                        <div className="space30"></div>
                        <div className="img1 image-anime reveal">
                          <img src="/assets/img/all-images/about/about-img3.png" alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="check-icons aniamtion-key-1">
                      <img src="/assets/img/icons/check1.svg" alt="check" />
                      <p>With 15+ years of experience IT solution help community.</p>
                    </div>
                  </div>
                </div>
    
                <div className="col-lg-1"></div>
    
                <div className="col-lg-5">
                  <div className="about-header-area heading2">
                    <h5>
                      <span>
                        <img src="/assets/img/icons/sub-logo1.svg" alt="sub-logo" />
                      </span>
                      About Chester IT Solution
                    </h5>
                    <div className="space24"></div>
                    <h2 className="text-anime-style-3">
                      To Be Your Complete Digital Partner—From Strategy to Launch and Beyond
                    </h2>
                    <div className="space16"></div>
                    <p data-aos="fade-left" data-aos-duration="800">
                     Over the past five years, we’ve collaborated with 50+ clients globally, crafting digital 
    solutions that drive efficiency, innovation, and user engagement. Whether it’s building 
    custom platforms, AI-powered tools, or enhancing existing systems, our mission is to fast
    track your digital vision with precision and excellence.
                    </p>
                    <div className="space28"></div>
    
                  <div className="row" data-aos="fade-left" data-aos-duration="900">
      {/* Agile methodology + certified professionals */}
      <div className="col-lg-6 col-md-6">
        <div className="progresbar text-center">
          <div className="icon-area mb-3">
            <i className="fa-solid fa-certificate fa-3x"></i>
          </div>
          <div className="content-area">
            <h6>Agile methodology + certified professionals</h6>
            <div className="space8"></div>
          </div>
        </div>
      </div>
    
      {/* Full-cycle capability */}
      <div className="col-lg-6 col-md-6">
        <div className="progresbar text-center">
          <div className="icon-area mb-3">
            <i className="fa-solid fa-diagram-project fa-3x"></i>
          </div>
          <div className="content-area">
            <h6>Full-cycle capability: strategy, design, development, QA, support</h6>
            <div className="space8"></div>
          </div>
        </div>
      </div>
    
      {/* Smooth team collaboration */}
      <div className="col-lg-6 col-md-6">
        <div className="progresbar text-center">
          <div className="icon-area mb-3">
            <i className="fa-solid fa-users fa-3x"></i>
          </div>
          <div className="content-area">
            <h6>Smooth team collaboration and knowledge-sharing</h6>
            <div className="space8"></div>
          </div>
        </div>
      </div>
    
      {/* Rapid turnaround */}
      <div className="col-lg-6 col-md-6">
        <div className="progresbar text-center">
          <div className="icon-area mb-3">
            <i className="fa-solid fa-bolt fa-2x me-2"></i>
            <i className="fa-solid fa-circle-check fa-2x"></i>
          </div>
          <div className="content-area">
            <h6>Rapid turnaround without compromising quality</h6>
            <div className="space8"></div>
          </div>
        </div>
      </div>
    </div>
    
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ===== ABOUT AREA ENDS ===== */}

      {/* ABOUT AREA 2 */}
      <div className="about6-section-area-widget sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="about6-header heading2">
                <h5><span><img src="assets/img/icons/sub-logo1.svg" alt="" /></span>our mission/vision</h5>
                <div className="space18"></div>
                <h2 className="text-anime-style-3">Driving Innovation: Our Mission Vision at Eitech</h2>
                <div className="space16"></div>
                <div className="space24"></div>
                <div className="about-boxarea" data-aos="fade-left" data-aos-duration="1000">
                    <p>We envision ourselves as one of the leading technology consulting and development firms in the digital space, providing world-class services that will propel your business to new heights</p>
                </div>
                <div className="space24"></div>
                <div className="about-boxarea" data-aos="fade-left" data-aos-duration="1000">
                    <p>At nexios, we are on a mission to become the preferred choice for technology development and consultancy services across the globe, powering business innovation and digitalization across multiple industries and business domains.</p>
                </div>
                <div className="space24"></div>
              </div>
            </div>
            <div className="col-lg-1"></div>
            <div className="col-lg-6">
              <div className="images-area">
                <img src="assets/img/elements/elements27.png" alt="" className="elements27" />
                <div className="img1 image-anime reveal">
                  <img src="assets/img/all-images/about/about-img13.png" alt="" />
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="img1 image-anime reveal">
                      <div className="space30"></div>
                      <img src="assets/img/all-images/about/about-img14.png" alt="" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="img1 image-anime reveal">
                      <div className="space30"></div>
                      <img src="assets/img/all-images/about/about-img15.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* TEAM AREA */}
      {/* <div className="team1-section-area sp2">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 m-auto">
              <div className="team-header space-margin60 heading2 text-center">
                <h5><span><img src="assets/img/icons/sub-logo1.svg" alt="" /></span>our best team</h5>
                <div className="space20"></div>
                <h2 className="text-anime-style-3">Meet Our Expert Team</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6" data-aos="zoom-in" data-aos-duration="800">
              <div className="team-author-boxarea">
                <div className="img1 image-anime">
                  <img src="assets/img/all-images/team/team-img1.png" alt="" />
                </div>
                <div className="content-area">
                  <div className="text">
                    <a href="team.html">SR. Alex Robertson</a>
                    <div className="space8"></div>
                    <p>Head Of Cybersecurity</p>
                  </div>
                  <div className="icons">
                    <a href="#"><img src="assets/img/icons/share1.svg" alt="" /></a>
                  </div>
                </div>
                <ul>
                  <li><a href="#"><i className="fa-brands fa-facebook-f"></i></a></li>
                  <li><a href="#"><i className="fa-brands fa-instagram"></i></a></li>
                  <li><a href="#"><i className="fa-brands fa-youtube"></i></a></li>
                  <li><a href="#"><i className="fa-brands fa-linkedin-in"></i></a></li>
                </ul>
              </div>
            </div>

            <div className="col-lg-4 col-md-6" data-aos="zoom-in" data-aos-duration="1000">
              <div className="team-author-boxarea">
                <div className="img1 image-anime">
                  <img src="assets/img/all-images/team/team-img2.png" alt="" />
                </div>
                <div className="content-area">
                  <div className="text">
                    <a href="team.html">Shelia Abernathy</a>
                    <div className="space8"></div>
                    <p>Software Development</p>
                  </div>
                  <div className="icons">
                    <a href="#"><img src="assets/img/icons/share1.svg" alt="" /></a>
                  </div>
                </div>
                <ul>
                  <li><a href="#"><i className="fa-brands fa-facebook-f"></i></a></li>
                  <li><a href="#"><i className="fa-brands fa-instagram"></i></a></li>
                  <li><a href="#"><i className="fa-brands fa-youtube"></i></a></li>
                  <li><a href="#"><i className="fa-brands fa-linkedin-in"></i></a></li>
                </ul>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6" data-aos="zoom-in" data-aos-duration="1200">
              <div className="team-author-boxarea">
                <div className="img1 image-anime">
                  <img src="assets/img/all-images/team/team-img3.png" alt="" />
                </div>
                <div className="content-area">
                  <div className="text">
                    <a href="team.html">Devin Romaguera</a>
                    <div className="space8"></div>
                    <p>Data Analytics Specialist</p>
                  </div>
                  <div className="icons">
                    <a href="#"><img src="assets/img/icons/share1.svg" alt="" /></a>
                  </div>
                </div>
                <ul>
                  <li><a href="#"><i className="fa-brands fa-facebook-f"></i></a></li>
                  <li><a href="#"><i className="fa-brands fa-instagram"></i></a></li>
                  <li><a href="#"><i className="fa-brands fa-youtube"></i></a></li>
                  <li><a href="#"><i className="fa-brands fa-linkedin-in"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* TESTIMONIAL AREA */}
      <div className="testimonial1-section-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 m-auto">
              <div className="testimonial-header text-center heading2 space-margin60">
                <h5><span><img src="assets/img/icons/sub-logo1.svg" alt="" /></span>Testimonials</h5>
                <div className="space20"></div>
                <h2 className="text-anime-style-3">Experience the Difference Through Our Clients' Eyes</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-5">
              <div className="img1 image-anime reveal">
                <img 
                  src="assets/img/all-images/testimonial/testimonial-img1.png" 
                  alt=""
                  style={{
                    transform: `translateX(${-100 + (currentTestimonial * 50)}px)`,
                    transition: 'transform 0.8s ease-in-out'
                  }}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="slider-galeria">
                <div 
                  className="testimonial-slider-content-area"
                  key={currentTestimonial}
                  style={{
                    transform: `translateX(${-50 + (currentTestimonial * 30)}px)`,
                    transition: 'transform 0.8s ease-in-out',
                    opacity: 1
                  }}
                >
                  <div className="testimonial-author-area">
                    <ul>
                      {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                        <li key={i}><a href="#"><i className="fa-solid fa-star"></i></a></li>
                      ))}
                    </ul>
                    <div className="space16"></div>
                    <img src="assets/img/icons/quito1.svg" alt="" className="quito1" />
                    <img 
                      src="assets/img/elements/elements18.png" 
                      alt="" 
                      className="elements18"
                      style={{
                        transform: `translateX(${currentTestimonial * 15}px)`,
                        transition: 'transform 0.8s ease-in-out'
                      }}
                    />
                    <p style={{
                      transform: `translateX(${currentTestimonial * 10}px)`,
                      transition: 'all 0.8s ease-in-out'
                    }}>{testimonials[currentTestimonial].text}</p>
                  </div>
                  <div className="space60"></div>
                  <div className="testimonial-man-info-area">
                    <div className="man-images-text">
                      <div className="mans-img">
                        <img 
                          src={testimonials[currentTestimonial].image} 
                          alt=""
                          style={{
                            transform: `translateX(${currentTestimonial * 20}px)`,
                            transition: 'transform 0.8s ease-in-out'
                          }}
                        />
                      </div>
                      <div className="man-text">
                        <a href="team1.html">{testimonials[currentTestimonial].name}</a>
                        <div className="space12"></div>
                        <p>{testimonials[currentTestimonial].position}</p>
                      </div>
                    </div>
                    <img 
                      src="assets/img/elements/elements17.png" 
                      alt=""
                      style={{
                        transform: `translateX(${currentTestimonial * 25}px)`,
                        transition: 'transform 0.8s ease-in-out'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-1">
              <div className="slider-galeria-thumbs text-center d-lg-block d-none">
                {testimonials.map((testimonial, index) => (
                  <div 
                    key={index}
                    className={`testimonial3-sliders-img ${index === currentTestimonial ? 'active' : ''}`}
                    onClick={() => setCurrentTestimonial(index)}
                    style={{
                      transform: index === currentTestimonial ? 'scale(1.1)' : 'scale(1)',
                      opacity: index === currentTestimonial ? 1 : 0.7,
                      transition: 'all 0.3s ease-in-out',
                      cursor: 'pointer'
                    }}
                  >
                    <img 
                      src={testimonial.image} 
                      alt=""
                      style={{
                        borderRadius: '50%',
                        transition: 'all 0.3s ease-in-out'
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Aboutus
